// Central data + config for the sales page

export const CART_URL = "https://almaencendida.store/cart/45985488994477:1";

export const HERO_POSTER =
  "https://cdn.magicpatterns.com/uploads/sZd8nrkW2niKpF4esdapNf/1000324389.png";

export const EBOOK_MOCKUP =
  "https://cdn.magicpatterns.com/patterns/generated-images/f2d62c16-4780-449f-9a51-6ba0942068ed.jpg";

export type Testimonial = {
  name: string;
  age: number;
  location: string;
  quote: string;
};

export const testimonials: Testimonial[] = [
  {
    name: "Camila Rojas",
    age: 27,
    location: "Córdoba, Argentina",
    quote:
      "Sentí alivio por primera vez en mucho tiempo. Dejé de mirar la vida de los demás en el celular y empecé a ordenar la mía. No sabía cuánto lo necesitaba.",
  },
  {
    name: "Martín Herrera",
    age: 31,
    location: "Guadalajara, México",
    quote:
      "Pensaba que había llegado tarde a todo. Este ebook me hizo entender que no estaba roto, solo perdido. Ahora avanzo sin correr una carrera contra nadie.",
  },
  {
    name: "Valentina Muñoz",
    age: 24,
    location: "Santiago, Chile",
    quote:
      "Los ejercicios son simples pero pegan fuerte. Dejé de castigarme por no tener todo resuelto a mi edad. Volví a enfocarme en mí y se nota.",
  },
  {
    name: "Sebastián Torres",
    age: 29,
    location: "Bogotá, Colombia",
    quote:
      "No es humo motivacional. Es directo y humano. Me ayudó a entender qué me estaba frenando de verdad y a ponerme objetivos que son míos, no de los demás.",
  },
  {
    name: "Lucía Fernández",
    age: 26,
    location: "Montevideo, Uruguay",
    quote:
      "Lo leí en dos tardes y cambió mi cabeza. Dejé de compararme constantemente y por fin siento que estoy construyendo algo propio. Lo recomiendo cerrado.",
  },
];

// Names + countries for the "someone just purchased" popup
export const purchaseNames = [
  "Sofía",
  "Mateo",
  "Valentina",
  "Diego",
  "Camila",
  "Nicolás",
  "Martina",
  "Joaquín",
  "Agustina",
  "Tomás",
  "Florencia",
  "Benjamín",
  "Isabella",
  "Emiliano",
  "Renata",
  "Gabriel",
  "Antonella",
  "Andrés",
];

export const purchaseCountries = [
  "Argentina",
  "México",
  "Chile",
  "Colombia",
  "Uruguay",
  "Perú",
  "España",
  "Ecuador",
  "Paraguay",
  "Bolivia",
  "Costa Rica",
  "Guatemala",
  "Panamá",
  "República Dominicana",
  "Venezuela",
];
